import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { ChevronUp, ChevronDown, Trash2 } from 'lucide-react';
import { api } from '../lib/api';

export default function OutboundRules() {
  const me = api.me();
  const qc = useQueryClient();
  const { data: rules = [] } = useQuery({
    queryKey: ['outbound', me?.domain_uuid],
    queryFn: () => me?.domain_uuid ? api.outboundRules.list(me.domain_uuid) : Promise.resolve([]),
    enabled: !!me?.domain_uuid,
  });
  const move = useMutation({
    mutationFn: ({ id, direction }: { id: string; direction: 'up' | 'down' }) =>
      api.outboundRules.move(me!.domain_uuid, id, direction),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['outbound', me?.domain_uuid] }),
  });
  const remove = useMutation({
    mutationFn: (id: string) => api.outboundRules.remove(me!.domain_uuid, id),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['outbound', me?.domain_uuid] }),
  });

  return (
    <div className="space-y-4">
      <h1 className="text-2xl font-semibold">Outbound Rules</h1>
      <div className="card p-0 overflow-hidden">
        <table className="table">
          <thead>
            <tr>
              <th></th>
              <th>Name</th>
              <th>Prefix</th>
              <th>From Ext</th>
              <th>Length</th>
              <th>Route 1</th>
              <th>Route 2</th>
              <th>Route 3</th>
              <th>Route 4</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {rules.map((r: any, i: number) => (
              <tr key={r.id} className="hover:bg-elevated">
                <td>
                  <button className="btn-ghost p-1" disabled={i===0} onClick={()=>move.mutate({ id: r.id, direction: 'up' })}><ChevronUp size={14} /></button>
                  <button className="btn-ghost p-1" disabled={i===rules.length-1} onClick={()=>move.mutate({ id: r.id, direction: 'down' })}><ChevronDown size={14} /></button>
                </td>
                <td>{r.name}</td>
                <td className="font-mono">{r.prefix}</td>
                <td className="font-mono">{r.call_from_ext}</td>
                <td>{r.length}</td>
                {(r.routes || []).slice(0, 4).map((rt: string, j: number) => (
                  <td key={j} className={rt === 'Blocked' ? 'text-textSecondary' : ''}>{rt}</td>
                ))}
                <td>
                  <button className="btn-ghost p-1 text-danger" onClick={()=>remove.mutate(r.id)}><Trash2 size={14} /></button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
